import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font
} from "@react-pdf/renderer";
import "../AddTransaction/TransactionReport.css";
import moment from "moment";

// import from assets and fonts
import mues_logo from "Assets/Image/logo/mues_logo_3d.png";

Font.register({
  family: "Helvetica",
  fonts: [
    {
      src: "https://fonts.gstatic.com/s/helvetica/v1/helveticabold.ttf",
      fontWeight: "bold",
    },
  ],
});

// Define styles
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    padding: 20,
    fontSize: 10,
    fontFamily: "Helvetica",
    fontStyle: "italic"
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 20,
  },
  logo: { width: 80, height: 30 },
  profile: { width: 70, height: 40 },
  title: { fontSize: 12, fontFamily: "Helvetica-Bold", marginBottom: 5 },
  billedContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 20,
  },
  billedColumn: { width: "48%" },
  boldText: { fontSize: 10, fontFamily: "Helvetica-Bold", marginBottom: 2 },
  table: {
    marginTop: 10,
    borderRadius: 8,
    overflow: "hidden",
    zIndex: 99,
  },
  row: {
    flexDirection: "row",
    padding: 5,
    backgroundColor: "#ccdeff",
  },
  tableHeader: {
    backgroundColor: "#6ea1ff",
    color: "white",
    fontWeight: "bold",
    padding: 5,
  },
  column: { flex: 1, textAlign: "left", padding: 2 },
  note: { marginTop: 10 },
  footerContainer: {
    marginTop: "auto", // Pushes footer to the bottom
    textAlign: "center",
    paddingTop: 10,
    borderTop: "1px solid #ccc",
  },
  footer: { fontSize: 8, color: "#555" },
  watermark: {
    position: "absolute",
    top: "40%",
    right: "5%",
    transform: "rotate(-40deg)",
    fontSize: 100,
    color: "rgba(20, 122, 22, 0.1)",
    fontWeight: "bold",
    zIndex: -1,
  },
  addressContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    width: "100%",
  },
  addressText: {
    flexShrink: 1,
    flexGrow: 1,
    paddingRight: 5, // Small spacing for wrapping
  },
  transaction_detail: {
    marginBottom: 20,
  },
  inLine: {
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    flexDirection: "row",
    marginBottom: 4,
  },
  transaction_info:{
    marginBottom: 2,
  }
});

// PDF Component
const PdfGenerator = (item, preschoolInformation) => (
  <Document>
    <Page size="A5" style={styles.page}>
      <Text style={styles.watermark}>CREAXT</Text>
      {/* Header */}
      <View style={styles.header}>
      <Image src={mues_logo} style={styles.logo} />
        <Image
          src={preschoolInformation?.preschool_logo}
          style={styles.profile}
        />
      </View>
      {/* Transaction Details */}
      <View style={styles.transaction_detail}>
        <Text style={styles.title}>Transaction Details</Text>
        <View style={styles.inLine}>
          <Text style={styles.inLineText}>Transaction Id: </Text>
          <Text>{item?.transactionId || "N/A"}</Text>
        </View>
        <View style={styles.inLine}>
          <Text style={styles.inLineText}>Transaction Date: </Text>
          <Text>
            {moment(item?.transactionDate).format("DD MMM YYYY") || "N/A"}
          </Text>
        </View>
      </View>

      {/* Billing Information */}
      <View style={styles.billedContainer}>
        <View style={styles.billedColumn}>
          <Text style={styles.boldText}>Billed To:</Text>
          <Text style={styles.transaction_info}>{item?.client_name || "N/A"}</Text>
        </View>
        <View style={styles.billedColumn}>
          <Text style={styles.boldText}>Billed By:</Text>
          <Text style={styles.transaction_info}>{preschoolInformation?.name || "N/A"}</Text>
          <View style={styles.addressContainer}>
            <Text style={styles.addressText}>
              {preschoolInformation?.address?.street || ""}, {preschoolInformation?.address?.city || ""}, {preschoolInformation?.address?.state || ""}, {preschoolInformation?.address?.country || ""}, {preschoolInformation?.address?.pincode || ""}
            </Text>
          </View>
        </View>
      </View>

      {/* Table */}
      <View style={styles.table}>
        <View style={[styles.row, styles.tableHeader]}>
          <Text style={styles.column}>Mode</Text>
          <Text style={styles.column}>Type</Text>
          <Text style={styles.column}>Price</Text>
          <Text style={styles.column}>Status</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.column}>{item?.payment_mode || "N/A"}</Text>
          <Text style={styles.column}>{item?.source || "N/A"}</Text>
          <Text style={styles.column}>{item?.amount || "N/A"}</Text>
          <Text style={styles.column}>{item?.transaction_status || "N/A"}</Text>
        </View>
      </View>

      {/* Note */}
      <Text style={styles.note}>
        Note: {item?.note || "No additional information"}
      </Text>

      {/* Footer */}
      <View style={styles.footerContainer}>
        <Text style={styles.footer}>
          Powered by mues, © {new Date().getFullYear()} Creaxt Innovations Private
          Limited
        </Text>
      </View>
    </Page>
  </Document>
);

export default PdfGenerator;

